<div class="modal-header">
  <h4 class="modal-title pull-left"> Manage Preset</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">

  <div class="no-items" *ngIf="presets.length == 0">
    no presets found
  </div>

  <div class="users-list mb-3">
    <div class="users" *ngIf="presets.length>0">
      <div class="item" *ngFor="let preset of presets; let i = index;">
        <div class="row">
          <div class="column col-md-11 user-column">
            <div class="user-info">
              <div class="user-name">
                {{preset.NAME}}
              </div>
            </div>
          </div>

          <div class="column end col-md-1 action">
            <button (click)="removePreset(preset, i)" type="button" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div style="width:100%;text-align:right;" class="pagination-wrapper" *ngIf="totalItems > 10">
    <pagination [totalItems]="totalItems" [itemsPerPage]="10" [(ngModel)]="currentPage" [maxSize]="5" [boundaryLinks]="true"
      [rotate]="false" (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <!-- <button type="button" class="btn btn-rbv" (click)="onSubmit()">Save</button> -->
</div>